import { FC, useCallback } from 'react'

import { dashboardv20240509Client } from '@sequencehq/api/dashboard/v20240509'
import { SimpleModal, useNotifications } from '@sequencehq/core-components'

export const ListPriceArchiveModal: FC<{
  listPriceId: string
  onClose: () => void
  onSuccess: () => void
}> = ({ listPriceId, onClose, onSuccess }) => {
  const { displayNotification } = useNotifications()

  const archiveListPrice = useCallback(async () => {
    const response = await dashboardv20240509Client.putListPriceArchive({
      id: listPriceId
    })

    if (response.error) {
      displayNotification('Failed to archive list price', { type: 'error' })
      return false
    }

    displayNotification('List price archived', { type: 'success' })
    onSuccess()

    return true
  }, [listPriceId, displayNotification, onSuccess])

  return (
    <SimpleModal
      isOpen
      data-testid="listPriceArchiveModal"
      variant="dialog"
      title="Archive list price"
      onClose={onClose}
      isDestructive
      submitButtonText="Archive"
      submittingButtonText="Archiving..."
      onSubmit={archiveListPrice}
    >
      The list price will be archived and will no longer be visible in billing
      schedules or quote builder.
    </SimpleModal>
  )
}
